// 收藏管理工具函数

const ASSETS_STORAGE_KEY = 'favorite_assets';
const VARIABLES_STORAGE_KEY = 'favorite_variables';

// 获取收藏的投资标的
export const getFavoriteAssets = (): string[] => {
  try {
    const stored = localStorage.getItem(ASSETS_STORAGE_KEY);
    return stored ? JSON.parse(stored) : [];
  } catch {
    return [];
  }
};

// 获取收藏的变量
export const getFavoriteVariables = (): string[] => {
  try {
    const stored = localStorage.getItem(VARIABLES_STORAGE_KEY);
    return stored ? JSON.parse(stored) : [];
  } catch {
    return [];
  }
};

// 添加收藏的投资标的
export const addFavoriteAsset = (asset: string): void => {
  if (!asset.trim()) return;
  const assets = getFavoriteAssets();
  const trimmedAsset = asset.trim();
  if (!assets.includes(trimmedAsset)) {
    assets.push(trimmedAsset);
    localStorage.setItem(ASSETS_STORAGE_KEY, JSON.stringify(assets));
  }
};

// 添加收藏的变量
export const addFavoriteVariable = (variable: string): void => {
  if (!variable.trim()) return;
  const variables = getFavoriteVariables();
  const trimmedVariable = variable.trim();
  if (!variables.includes(trimmedVariable)) {
    variables.push(trimmedVariable);
    localStorage.setItem(VARIABLES_STORAGE_KEY, JSON.stringify(variables));
  }
};

// 删除收藏的投资标的
export const removeFavoriteAsset = (asset: string): void => {
  const assets = getFavoriteAssets();
  const filtered = assets.filter(a => a !== asset);
  localStorage.setItem(ASSETS_STORAGE_KEY, JSON.stringify(filtered));
};

// 删除收藏的变量
export const removeFavoriteVariable = (variable: string): void => {
  const variables = getFavoriteVariables();
  const filtered = variables.filter(v => v !== variable);
  localStorage.setItem(VARIABLES_STORAGE_KEY, JSON.stringify(filtered));
};

// 检查是否已收藏
export const isAssetFavorite = (asset: string): boolean => {
  return getFavoriteAssets().includes(asset.trim());
};

export const isVariableFavorite = (variable: string): boolean => {
  return getFavoriteVariables().includes(variable.trim());
};






